const REQ_FORBEARANCE_PLAN = 'Natural Disaster Assistance';
const REQ_FORBEARANCE_PLAN_DESCRIPTION = 'Has a Natural Disaster damaged your home, impacted your employment, or caused a financial hardship impacting your ability to make timely mortgage payments?';
const REQUEST_A_FORBEARANCE = 'REQUEST ASSISTANCE';
const FEMA_HELPLINE = 'FEMA Helpline';
const FEMA_HELPLINE_DES = 'The FEMA Helpline (800-621-3362) may be able to provide referrals and guidance on their ';
const FEMA_POLICY_URL = 'https://www.fema.gov/assistance/individual/policy-guidance-and-fact-sheets';
const FEMA_POLICY_TEXT = 'Individuals and Households Program (IHP)';
const FEMA_HELPLINE_DESC_TWO = '. If you use video relay service (VRS), captioned telephone service or others, give FEMA your number for that service.';
const FMC_HELPLINE_NO = '800-621-3362';
const FEMA_LEARN_MORE_URL = 'https://www.fema.gov/assistance/individual';
const LEARN_MORE = 'LEARN MORE';
const RED_CROSS_CONTENT = 'Red Cross Content';
const DRAFT_CONTENT = 'Draft Content';
const ADDITIONAL_CONTENT = 'Additional Content';
const RED_CROSS_CONTENT_URL = 'https://www.freedommortgage.com/contenthandler/!ut/p/digest!vtlU83TUl-HeINCi_ZZcqA/wcmrest-v2/contents/22b37870-d77f-4adc-a95f-23abfabdc119?skipHistory=true';
const DRAFT_CONTENT_URL = 'https://www.freedommortgage.com/contenthandler/!ut/p/digest!vtlU83TUl-HeINCi_ZZcqA/wcmrest-v2/contents/0cfefc02-7973-405f-90e1-ace15e657c8b?skipHistory=true';
const ADDITIONAL_CONTENT_URL = 'https://www.freedommortgage.com/contenthandler/wcmrest-v2/contents/e55b94fa-cf09-4c9b-9a13-ed82db114837?skipHistory=true';
const RED_CROSS_QUERY_KEY = 'fetch-red-cross-content';
const DRAFT_QUERY_KEY = 'fetch-draft-content';
const ADDITIONAL_QUERY_KEY = 'fetch-additional-content';
const SUCCESS_FORBEARANCE_MESSAGE = 'Thank you for submitting your request about a forbearance plan.  We will be in touch soon.';
const FAILURE_FORBEARANCE_MESSAGE = 'Something went wrong on our end.  Please call 855-690-5900 to complete the request for your forbearance plan.';
const REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_1 = 'You may be eligible for a Natural Disaster Forbearance Plan ("Plan"). This Plan is a temporary suspension of mortgage payments intended to help eligible customers manage financial challenges.';
const REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_2 = 'If you are eligible for a Plan, we will work with you near the end of the Plan to determine what long-term solutions may be available. Payments missed during a Plan are not forgiven. The process to get caught up on missed payments is not automatic. It is important to remain engaged.';
const REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_3 = 'If you would like to request a Plan, please click Request Assistance below and we will determine your eligibility. We encourage you to continue to make mortgage payments, if you can, until you hear from us.';
const FORBEARANCE_CARDS_CONTENT = [{
  id: '1',
  metadata: {
    borderLeftColor: '#D1D3D4',
    borderRightColor: 'rgba(151,151,151,0.36)',
    borderTopColor: 'rgba(151,151,151,0.36)',
    borderBottomColor: 'rgba(151,151,151,0.36)',
    shadow: 10
  },
  header: {
    icon: 'FEMA',
    title: {
      content: '[header]',
      type: 'text',
      metadata: {
        values: {
          header: 'FEMA Helpline'
        }
      }
    }
  },
  body: [{
    content: '[copy]',
    type: 'text',
    metadata: {
      values: {
        copy: 'The FEMA Helpline (800-621-3362) may be able to provide referrals and guidance on their '
      },
      display: 'flex',
      flexDirection: 'row'
    }
  }, {
    content: '[linkText]',
    type: 'linkText',
    metadata: {
      values: {
        linkText: 'Individuals and Households Program (IHP)'
      },
      href: 'https://www.fema.gov/assistance/individual/program',
      textDecorationLine: 'underline',
      textDecorationColor: 'primary.400',
      fontSize: '16px'
    },
    event: {
      action: 'DisasterFEMALinkClicked'
    }
  }, {
    content: '. If you use video relay service (VRS), captioned telephone service or others, give FEMA your number for that service.',
    type: 'text'
  }],
  callToActions: [{
    type: 'dial-in',
    content: '[tollFreeNo]',
    metadata: {
      href: 'tel:[tollFreeNo]',
      fontWeight: 'medium',
      values: {
        tollFreeNo: '800-621-3362'
      }
    },
    event: {
      action: 'DisasterFEMACallClicked'
    }
  }, {
    type: 'separator',
    content: 'OR'
  }, {
    type: 'cta-link',
    content: '[learnMore]',
    metadata: {
      fontWeight: 'medium',
      values: {
        learnMore: 'LEARN MORE'
      },
      href: 'https://www.fema.gov/assistance/individual/policy-guidance-and-fact-sheets'
    },
    event: {
      action: 'DisasterFEMASiteClicked'
    }
  }]
}, {
  id: '4',
  metadata: {
    borderLeftColor: '#D1D3D4',
    borderRightColor: 'rgba(151,151,151,0.36)',
    borderTopColor: 'rgba(151,151,151,0.36)',
    borderBottomColor: 'rgba(151,151,151,0.36)',
    shadow: 10
  },
  header: {
    icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/cf1d185b-4640-4b07-83ce-44b1b9f2ad90/items/1b30a62d-6080-425c-92a0-55f06659733e/renditions/328c461e-a145-4add-b4ba-aab4bb8e609a?binary=true',
    title: {
      content: '[header]',
      type: 'text',
      metadata: {
        values: {
          header: 'Red Cross'
        }
      }
    }
  },
  body: [{
    content: 'If an emergency has forced you to evacuate your home, the Red Cross may be able to help. Click on find a shelter to locate your nearest location.',
    type: 'text'
  }],
  callToActions: [{
    type: 'cta-link',
    content: '[findAShelter]',
    metadata: {
      fontWeight: 'medium',
      values: {
        findAShelter: 'FIND A SHELTER'
      },
      href: 'https://www.redcross.org/get-help/disaster-relief-and-recovery-services/find-an-open-shelter.html'
    },
    event: {
      action: 'DisasterRedCrossSiteClicked'
    }
  }]
}, {
  id: '2',
  metadata: {
    borderLeftColor: '#D1D3D4',
    borderRightColor: 'rgba(151,151,151,0.36)',
    borderTopColor: 'rgba(151,151,151,0.36)',
    borderBottomColor: 'rgba(151,151,151,0.36)',
    shadow: 10
  },
  header: {
    icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/1dabd9ce-61f2-4811-a434-d9808c80529e/renditions/35df17e0-5afe-4b47-bd8f-673131e994e2?binary=true',
    title: {
      content: '[header]',
      type: 'text',
      metadata: {
        values: {
          header: 'Loss Draft Insurance Process'
        }
      }
    }
  },
  body: [{
    content: 'You will want to contact your insurance company as soon as possible to initiate your claim. Click on the learn more link for detailed information on getting your claim paid out as soon as possible.',
    type: 'text'
  }],
  callToActions: [{
    type: 'cta-link',
    content: '[learnMore]',
    metadata: {
      fontWeight: 'medium',
      values: {
        learnMore: 'LEARN MORE'
      },
      href: 'https://www.freedommortgage.com/customer-center/articles/insurance-department'
    },
    event: {
      action: 'DisasterLossDraftInsuranceProcessClicked'
    }
  }]
}, {
  id: '3',
  metadata: {
    borderLeftColor: '#D1D3D4',
    borderRightColor: 'rgba(151,151,151,0.36)',
    borderTopColor: 'rgba(151,151,151,0.36)',
    borderBottomColor: 'rgba(151,151,151,0.36)',
    shadow: 10
  },
  header: {
    icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/98617891-9e38-4a62-abfd-dcc3ff5ff756/renditions/bfb89a97-02e9-4e08-8992-c934b13c70eb?binary=true',
    title: {
      content: '[header]',
      type: 'text',
      metadata: {
        values: {
          header: 'Find additional help'
        }
      }
    }
  },
  body: [{
    content: 'Need help with finances? Health Services? Food? Legal assistance? Our partner SpringFour can connect you with all of these services and more.',
    type: 'text'
  }],
  callToActions: [{
    type: 'cta-link',
    content: '[learnMore]',
    metadata: {
      fontWeight: 'medium',
      values: {
        learnMore: 'LEARN MORE'
      },
      href: 'https://www.freedommortgage.com/natural-disaster'
    },
    event: {
      action: 'DisasterFindAdditionalHelpSiteClicked'
    }
  }]
}];
const NaturalDisasterConstants = {
  REQ_FORBEARANCE_PLAN,
  REQ_FORBEARANCE_PLAN_DESCRIPTION,
  REQUEST_A_FORBEARANCE,
  FEMA_HELPLINE,
  FEMA_HELPLINE_DES,
  FEMA_POLICY_URL,
  FEMA_POLICY_TEXT,
  FEMA_HELPLINE_DESC_TWO,
  FMC_HELPLINE_NO,
  FEMA_LEARN_MORE_URL,
  LEARN_MORE,
  RED_CROSS_CONTENT,
  DRAFT_CONTENT,
  ADDITIONAL_CONTENT,
  RED_CROSS_CONTENT_URL,
  DRAFT_CONTENT_URL,
  ADDITIONAL_CONTENT_URL,
  RED_CROSS_QUERY_KEY,
  DRAFT_QUERY_KEY,
  ADDITIONAL_QUERY_KEY,
  SUCCESS_FORBEARANCE_MESSAGE,
  FAILURE_FORBEARANCE_MESSAGE,
  FORBEARANCE_CARDS_CONTENT,
  REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_1,
  REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_2,
  REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_3
};
export default NaturalDisasterConstants;
//# sourceMappingURL=index.js.map